import { render, staticRenderFns } from "./AdminShowHome.vue?vue&type=template&id=6f6eded4"
import script from "./AdminShowHome.vue?vue&type=script&lang=js"
export * from "./AdminShowHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports